const stroke = '#EAEAEA';
const disabledBackgroundColor = stroke;
const greyLight = '#EEE';
const borderColor = greyLight;
const grey = '#AFB1B6';
const disabledTextColor = grey;
const hoverBorderColor = grey;
const placeholderColor = grey;
/* eslint-disable camelcase */
export const themeColors = {
  alpha50: 'rgba(17, 17, 17, 0.5)',
  bg: '#F7F7F8',
  // new colors
  // // greyscale
  black: '#111111',
  // Colors with an alpha channel
  black_65: 'rgba(29, 29, 27, 0.65)',
  black_80: 'rgba(29, 29, 27, 0.8)',
  blue: '#006FBA',
  borderColor,
  brandingBg: '#EAEAEA',
  coolGrey: '#a2aaad',
  darkBlue: '#005A97',
  darkGreen: '#025740',
  darkGrey: '#303030',
  darkRed: '#a20c16',
  darkSkyBlue: '#56b7e6',
  disabledBackgroundColor,
  disabledTextColor,
  gray10: '#f7f8fa',
  gray15: '#F0F0F0',
  // // system colors
  gray5: '#fbfbfb',
  green: '#0D7B60',
  grey,
  greyLight: '#EEE',
  hoverBorderColor,
  lightGreen: '#DDFFF7',
  lightGrey: '#D8D8DA',
  lightPurple: '#801EFF',
  ocd: 'rgb(241,111,2)',
  ocdDark: 'rgb(207,91,0)',
  oceanBlue: '#0067b9',
  // new colors end

  placeholderColor,
  primary: '#0057B8',
  purple: '#F2E8FF',
  red: '#BD2832',
  redPink: '#e40046',
  silver: '#d0d3d4',
  silver_20: 'rgba(208, 211, 212, 0.2)',
  silver_40: 'rgba(208, 211, 212, 0.4)',
  silver_70: 'rgba(208, 211, 212, 0.7)',
  silverTwo: '#dee0e0',
  spinnerColor: '#3f51b5',
  starYellow: '#ffb400',
  steelGrey: '#7c878e',
  stroke,
  turquoise: '#15BEF0',
  turquoiseBlue: '#00a5bd',
  turquoiseDark: '#05a1d0',
  turquoiseLight: '#bce1ec',
  white: '#FFFFFF',
  whiteGray: '#f6f6f6',
  whiteGray2: '#d8d8d8',

  yellow: '#ffb500',
  yellow76: 'rgba(252,250,234,0.76)',
} as const;

/** Archiving is reversible, so it uses the brand orange instead of the destructive red. */
export const ARCHIVE_COLOR = themeColors.ocd;
